module.exports = __webpack_public_path__ + "static/media/Helioptile_gaussian2.21d4d516.png";